const eventTypes = {
	UNCATEGORIZED: 0,
	RUNTIME_ERROR: 1,
	MACHINE_HAS_STARTED: 2,
	MACHINE_MALFUNCTION: 3,
	PRODUCTS_DiD_NOT_VEND: 4,
	PRODUCT_RUN_OUT_OF_STOCK: 5,
	STOCK_WARNING: 6,
	PRODUCTS_DISABLED: 7,
	MACHINE_IS_HEATING: 8,
	OUT_OF_CUPS: 9,
	OUT_OF_SMALL_CUPS: 10,
	OUT_OF_ESPRESSO: 11,
	OUT_OF_CHANGE: 12,
	MAINTENANCE: 13,
	PRODUCT_PURCHASED: 14,
	MACHINE_STATE_CHANGE: 15, // This event type is not show on the event listing views,
	// because It is not provided by the event system.
	// Instead it is the result of the keep alive/hearbeat message.
	INVISIBLE_TOUCH_MOBILE_ERROR: 16,
	MACHINE_WENT_OFFLINE: 17,
	MACHINE_STATE_CHANGE_REPORT: 18, // This event type is not show on the event listing views,
	NO_WATER_ERROR: 19,
	TURBINE_ERROR: 20,	
	HARDWARE_TIME_ERROR: 21,
	ERROR_LIST: 22,
	PROG_MODE_LIST: 23,


	PRICE_CHECK_STARTED: 24,
	PRICE_CHECK_RESULT: 25,

	LAYOUT_CHANGED: 26,
	LAYOUT_OVERRIDE_CHANGED: 27,
};

export default eventTypes;
